// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientActivityLogs_container__1pZgt"};